module.exports = "/packs/images/home/pod-9abe31bdf1e24d54c716c26a143aa5f7.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/home/pod.png
// module id = 1822
// module chunks = 0